var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-header",
    { staticClass: "layout-header", attrs: { height: _vm.setHeaderHeight } },
    [_c("NavBarsIndex")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }